import React, { memo } from "react"
import ServiceCard from "./ServiceCard"

const Whychooseourdevelopers = ({ data }) => {
  return (
    <div className="Whychooseourdevelopers">
      <h1 className="heading">Why Teams Trust Us to Extend Their Workforce</h1>
      <div className="service-cards-wrapper">
        <ServiceCard
          img_src={data.div1Img.childImageSharp.fluid.src}
          img_alt="Senior developers with proven expertise"
          card_heading="Senior Talent, Vetted Rigorously"
          card_para="Every developer we place has been assessed for real-world delivery, not just theory. You get professionals who ramp up fast, write clean code, and need minimal hand-holding."
        />
        <ServiceCard
          img_src={data.div2Img.childImageSharp.fluid.src}
          img_alt="Track record across industries"
          card_heading="A Track Record You Can Verify"
          card_para="Our developers have shipped production systems across finance, logistics, healthcare, and retail. You can review their work before committing — no surprises after onboarding."
        />
        <ServiceCard
          img_src={data.div3Img.childImageSharp.fluid.src}
          img_alt="Developers matched to your stack and workflows"
          card_heading="Matched to Your Stack and Culture"
          card_para="We don't send generic CVs. We match developers to your specific technologies, team size, and ways of working — so they integrate with your team, not just fill a seat."
        />
        <ServiceCard
          img_src={data.div4Img.childImageSharp.fluid.src}
          img_alt="Fast onboarding, on-time delivery"
          card_heading="Ready to Deliver Within Days"
          card_para="Slow hiring costs sprints. Our augmented developers are briefed, onboarded, and contributing within days — keeping your roadmap on schedule without the usual ramp-up lag."
        />
        <ServiceCard
          img_src={data.div5Img.childImageSharp.fluid.src}
          img_alt="Transparent communication and progress visibility"
          card_heading="Your Account Manager Stays Involved"
          card_para="You get a dedicated account manager throughout the engagement — not just at kickoff. Issues get resolved before they escalate, and you always know what your team is working on."
        />
        <ServiceCard
          img_src={data.div6Img.childImageSharp.fluid.src}
          img_alt="Cost-effective staff augmentation"
          card_heading="Top-Tier Talent at a Fraction of the Cost"
          card_para="Hiring full-time senior developers in Western markets is expensive and slow. Our model gives you the same calibre of talent at significantly lower cost — with no long-term commitment required."
        />
      </div>
    </div>
  )
}

export default memo(Whychooseourdevelopers)
